<template>
  <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0001 0H8.9999C8.9999 1.25101 8.10451 2.26516 7 2.26516C5.89549 2.26516 5.0001 1.25101 5.0001 0H1.9999C0.895384 0 0 1.01415 0 2.26516V14.2433H14V2.26516C13.9996 1.01434 13.1044 0.000453444 12.0001 0ZM9.25368 11.9429L6.97379 10.5856L4.69389 11.9429L5.12913 9.06724L3.28519 7.03131L5.8342 6.61147L6.97379 3.99548L8.11337 6.61147L10.6624 7.03131L8.81845 9.06724L9.25368 11.9429Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 15.2524V18.057C0 19.1302 0.895384 20.0002 1.9999 20.0002H5.0001C5.0001 18.927 5.89549 18.057 7 18.057C8.10451 18.057 8.9999 18.927 8.9999 20.0002H12.0001C13.1044 19.9998 13.9996 19.13 14 18.057V15.2524H0Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: 'voucherSvg',
};
</script>

<style scoped></style>
